import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SingleLineCaption from './../dom-elements/SingleLineCaption';
import FilmHoverClip from './FilmHoverClip';
import { returnCategories, bgImage } from './../../scripts';
import { breakpoints } from './../../styles/theme.json';

const FilmArtGrid = (props) => {
  const Grid = props.GridItems.map((item, i) =>
    <li className={'img-grid-li ' + props.Page} key={'film-art-grid-' + item.image.id}>
      <Link to={'/' + item.link.postType + '/' + item.link.slug}>
        <div className={'grid-item-link'}>
          {(props.Page == 'film')
            ? <FilmHoverClip itemData={item}/>
            : (props.Page == 'fine-art') && <div className={'img-wrapper-fine-art ' + returnCategories(item.nav_categories)} style={bgImage(item.image.small)} />
          }
          {(props.window_width >= breakpoints.desktop)
            ? <div className={'film-caption'}>
                <div className={'caption-wrapper'}>
                  <SingleLineCaption Headline={item.project_caption.headline} Description={item.project_caption.description} Sep={true}/>
                </div>
              </div>
            : <div className={'film-caption'}>
                <SingleLineCaption Headline={item.project_caption.headline} Description={item.project_caption.description} Stacked={true}/>
              </div>
          }
        </div>
      </Link>
    </li>
  );
  return (
    <section id={'filter-grid'}>
      <ul className="grid-wrapper">
        {Grid}
      </ul>
      <div id={'external-links'}>
        {(props.Page == 'film')
        ? <ul className={'external-link-list'}>
            <li className={'link-item'}>
              <a className={'external-link'} href={props.vimeoLink} target={'_blank'}>{'Browse the Archive'}</a>
            </li>
            <li className={'link-item'}>
              <Link className={'external-link'} to={'/about'}>{'View Full Filmography'}</Link>
            </li>
          </ul>
        : <ul className={'external-link-list'}>
            <li className={'link-item'}>
              <Link className={'external-link'} to={'/galleries'}>{'Gallery List'}</Link>
            </li>
            <li className={'link-item'}>
              <a className={'external-link'} href={'#'} target={'_blank'}>{'View Full Exhibitions'}</a>
            </li>
          </ul>
        }
      </div>
    </section>
  );
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width,
    vimeoLink: state.staticContent.homeData.data.social_links[1].link
  })
)(FilmArtGrid);



// WEBPACK FOOTER //
// ./src/components/filter-pages/FilmArtGrid.js